export default "__VITE_ASSET__B7xT_DSY__"